const host = "/api";

export default host;
export const app_api = "https://app-api.home.sdic.com.cn/";
export const community_host = "/community-service";

export const maintenance_url =
  "https://hdjz-test.oss-cn-beijing.aliyuncs.com/file/public/json-feasibility-624749785259732715-OP0001.json";
